var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1531_3818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 1.33333C4.31992 1.33333 1.33325 4.31999 1.33325 8C1.33325 11.68 4.31992 14.6667 7.99992 14.6667C11.6799 14.6667 14.6666 11.68 14.6666 8C14.6666 4.31999 11.6799 1.33333 7.99992 1.33333ZM7.99992 13.3333C5.05325 13.3333 2.66659 10.9467 2.66659 8C2.66659 5.05333 5.05325 2.66666 7.99992 2.66666C10.9466 2.66666 13.3333 5.05333 13.3333 8C13.3333 10.9467 10.9466 13.3333 7.99992 13.3333Z",
    fill: "#0094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 11.3333C9.84103 11.3333 11.3334 9.84095 11.3334 8C11.3334 6.15906 9.84103 4.66667 8.00008 4.66667C6.15913 4.66667 4.66675 6.15906 4.66675 8C4.66675 9.84095 6.15913 11.3333 8.00008 11.3333Z",
    fill: "#0094FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1531_3818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.ab92e6f48eb0e810ddb183e1ae09b10e.svg";
export { ForwardRef as ReactComponent };